module.exports = __webpack_public_path__ + "img/lisence.2a068e7c.png";